enum KeyFactorThresholdDirection {
  HigherIsBetter = 1, // Higher values are "better" on the range of possible values
  LowerIsBetter = 2, // Lower values are "better" on the range of possible values
}

export interface KeyFactorThresholds {
  keyFactors: KeyFactorThreshold[];
}

export interface KeyFactorThreshold {
  fieldName: string;
  minWarnThreshold: string;
  minGoodThreshold: string;
  direction: string;
}

// Which section of the KeyFactorThreshold the value falls into
export enum KeyFactorThresholdSection {
  Bad = 1,
  Warn = 2,
  Good = 3,
}

// Shape of the result of a KeyFactorThreshold check when a validator business rule runs.
export interface KeyFactorValidationResult {
  section: KeyFactorThresholdSection;
  threshold: KeyFactorThreshold;
}